import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '@/store';
import { logout as logoutAction, setTenantDomain } from '@/store/slices/authSlice';
import { useLoginMutation, useLogoutMutation, useMeQuery } from '@/store/api/authApi';
import { baseApi } from '@/store/api/baseApi';

export function useAuth() {
  const dispatch = useAppDispatch();
  const { user, isAuthenticated, accessToken, mfaPending, tenantDomain } = useAppSelector(
    (state) => state.auth
  );

  const [loginMutation, { isLoading: isLoggingIn }] = useLoginMutation();
  const [logoutMutation] = useLogoutMutation();

  const { refetch: refetchMe } = useMeQuery(undefined, {
    skip: !accessToken,
  });

  const login = useCallback(
    async (email: string, password: string, domain?: string) => {
      if (domain) {
        dispatch(setTenantDomain(domain));
      }
      return loginMutation({ email, password, tenantDomain: domain }).unwrap();
    },
    [dispatch, loginMutation]
  );

  const logout = useCallback(async () => {
    try {
      await logoutMutation().unwrap();
    } catch {
      // Logout even if API call fails
    } finally {
      dispatch(logoutAction());
      dispatch(baseApi.util.resetApiState());
    }
  }, [dispatch, logoutMutation]);

  return {
    user,
    isAuthenticated,
    isLoggingIn,
    mfaPending,
    tenantDomain,
    login,
    logout,
    refetchMe,
  };
}
